import './FAQ.scss';
import toList from '../utils/ComponentUtil';
import CustomAccordion from '../utils/CustomAccordion';
import CustomButton from '../utils/CustomButton';
import Header from '../utils/Header';
import FAQImg from '../../images/Group_742.png';
import { East } from '@mui/icons-material';
import { Link } from 'react-router-dom';

function FAQ({ faqs = [{
    id: 1,
    question: "How is jobfi.in different from other job-providing platforms?",
    answer: "The evaluation process takes approximately 24 hours."

},
{
    id: 2,
    question: "How long does it take for the result of my application to be out?",
    answer: "The evaluation process takes approximately 24 hours."
},
{
    id: 3,
    question: "Is jobfi.in a staffing firm or a recruitment firm ?",
    answer: "The evaluation process takes approximately 24 hours."
}
], noImg = false }) {
    return (
        <div className="faq-wrp wrapper" id='faq'>
            { !noImg && <img className='faq-img' src={FAQImg} alt='faq' /> }
            <div className='faq-content-wrp'>
                <Header title='Frequently Asked Questions' subTitle='Clear your questions here' />
                <div className="questions-wrp">
                    <CustomAccordion accordians={toList(faqs, undefined, (item, i) => {
                        return {
                            summary: <div className='accordian-summary'>
                                <div className='question-no'>{i + 1}</div>
                                <div>{item.question}</div>
                            </div>,
                            details: <div className='accordian-details'>{item.answer}</div>
                        }
                    })}></CustomAccordion>
                </div>
                <Link reloadDocument={true} to={'/faq'} ><CustomButton name='View More Questions' icon={<East/>}/></Link>
            </div>
        </div>
    );
}

export default FAQ;